export const demoConversations = [
  {
    id: 'demo-manager-conversation',
    organiserName: 'You (Demo Manager)',
    attendeeName: 'Sarah Johnson',
    attendeeEmail: 'sarah.johnson@company.com',
    isOrganiserManager: true,
    isUserManager: true,
    isCanvasData: false,
    status: 0,
    employeePrepStatus: 2,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isDemo: true
  },
  {
    id: 'demo-1',
    organiserName: 'Jane Smith',
    attendeeName: 'Michael Chen',
    attendeeEmail: 'michael.chen@company.com',
    isOrganiserManager: true,
    isUserManager: false,
    isCanvasData: false,
    status: 2,
    employeePrepStatus: 2,
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    isDemo: true
  },
  {
    id: 'demo-completed-conversation',
    organiserName: 'You (Demo Manager)',
    attendeeName: 'Alex Thompson',
    attendeeEmail: 'alex.thompson@company.com',
    isOrganiserManager: true,
    isUserManager: true,
    isCanvasData: true,
    status: 2,
    employeePrepStatus: 2,
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    isDemo: true
  },
  {
    id: 'demo-2',
    organiserName: 'Jane Smith',
    attendeeName: 'Emma Williams',
    attendeeEmail: 'emma.williams@company.com',
    isOrganiserManager: true,
    isUserManager: false,
    isCanvasData: false,
    status: 1,
    employeePrepStatus: 1,
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    isDemo: true
  },
  {
    id: 'demo-3',
    organiserName: 'Jane Smith',
    attendeeName: 'David Martinez',
    attendeeEmail: 'david.martinez@company.com',
    isOrganiserManager: true,
    isUserManager: false,
    isCanvasData: false,
    status: 0,
    employeePrepStatus: 0,
    createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    isDemo: true
  },
  {
    id: 'demo-4',
    organiserName: 'Jane Smith',
    attendeeName: 'Lisa Anderson',
    attendeeEmail: 'lisa.anderson@company.com',
    isOrganiserManager: true,
    isUserManager: false,
    isCanvasData: false,
    status: 1,
    employeePrepStatus: 2,
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    isDemo: true
  },
  {
    id: 'demo-5',
    organiserName: 'Jane Smith',
    attendeeName: 'James Wilson',
    attendeeEmail: 'james.wilson@company.com',
    isOrganiserManager: true,
    isUserManager: false,
    isCanvasData: false,
    status: 0,
    employeePrepStatus: 1,
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    isDemo: true
  }
];

export const demoUser = {
  id: 'demo-user',
  firstname: 'Demo',
  lastname: 'Manager',
  email: 'demo@forwardtogether.com',
  isManager: true,
  token: 'demo-token',
  isDemo: true
};

export const demoSteps = [
  {
    id: 1,
    title: 'Welcome to Forward Together Demo',
    description: 'This demo will show you how to manage team conversations and track employee wellbeing.',
    target: '.page-content__header',
    placement: 'bottom'
  },
  {
    id: 2,
    title: 'Create New Conversations',
    description: 'Click here to start a new conversation with a team member.',
    target: '#page-navigation-button--create',
    placement: 'bottom'
  },
  {
    id: 3,
    title: 'Team Member Preparation',
    description: 'Experience the complete team member preparation journey including questionnaire and topic selection.',
    target: '.conversations-filter-form',
    placement: 'left'
  },
  {
    id: 4,
    title: 'Questionnaire Process',
    description: 'Complete the wellbeing questionnaire to identify priority areas for discussion.',
    target: '.js--data-table-wrap',
    placement: 'top'
  },
  {
    id: 5,
    title: 'Topic Selection - Self Guided',
    description: 'Choose your own conversation topics using the self-guided route.',
    target: '.data-table__faux-button--in-progress',
    placement: 'top'
  },
  {
    id: 6,
    title: 'Topic Selection - Results Based',
    description: 'Review and edit priority topics identified from questionnaire responses.',
    target: '.data-table__faux-button--in-progress',
    placement: 'top'
  },
  {
    id: 7,
    title: 'Conversation Topics',
    description: 'See how topics are displayed with proper colors, descriptions, and "More" button functionality.',
    target: '.category-form-field',
    placement: 'top'
  },
  {
    id: 8,
    title: 'Topic Details',
    description: 'Click "More" on any topic to view detailed descriptions and guidance.',
    target: '.category-form-field__link',
    placement: 'top'
  },
  {
    id: 9,
    title: 'Preparation Complete',
    description: 'See the completion page that summarizes the team member preparation process.',
    target: '.page-content__title',
    placement: 'bottom'
  },
  {
    id: 10,
    title: 'Demo Complete',
    description: 'You\'ve experienced the full demo! Click "Exit Demo" to return to the main application.',
    target: '.demo-banner__exit-button',
    placement: 'bottom'
  }
];
